import { ISetSettingsRequest } from '../../repositories/cian-chat-bot/entities/settings/SetSettingsRequest';
import {
  fetchPublicMobileV1SetSettings,
  TPublicMobileV1SetSettingsResponse,
} from '../../repositories/cian-chat-bot/mobile/v1/set-settings';
import { TContext } from '../../types/context';

type TChatbotSetSettingsContext = Pick<TContext, 'httpApi' | 'logger'>;

type TProps = Pick<ISetSettingsRequest, 'periodicity'>;

export async function chatbotSetSettings({ httpApi, logger }: TChatbotSetSettingsContext, { periodicity }: TProps) {
  try {
    const { response, statusCode }: TPublicMobileV1SetSettingsResponse = await fetchPublicMobileV1SetSettings({
      httpApi,
      parameters: {
        periodicity,
      },
    });

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        domain: 'src/shared/services/chatbotSetSettings/chatbotSetSettings.ts [chatbotSetSettings]',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        message: 'Не удалось сохранить настройки',
        errors: JSON.stringify(response?.errors),
      });

      return null;
    }

    return response.messages;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/chatbotSetSettings/chatbotSetSettings.ts [chatbotSetSettings]',
      message: 'Не удалось сохранить настройки',
    });

    return null;
  }
}
